import {
  AI_CHAT_REQUEST, AI_CHAT_SUCCESS, AI_CHAT_FAILURE,
  AI_PRESUPUESTO_REQUEST, AI_PRESUPUESTO_SUCCESS, AI_PRESUPUESTO_FAILURE,
  AI_CLEAR_SESSION,
} from '../Action-types';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  sessionId: uuidv4(),
  loading: false,
  presupuestoLoading: false,
  lastPresupuesto: null,
  error: null,
};

const aiReducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_CHAT_REQUEST:
      return { ...state, loading: true, error: null };
    case AI_CHAT_SUCCESS:
      return { ...state, loading: false };
    case AI_CHAT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case AI_PRESUPUESTO_REQUEST:
      return { ...state, presupuestoLoading: true, error: null };
    case AI_PRESUPUESTO_SUCCESS:
      return { ...state, presupuestoLoading: false, lastPresupuesto: action.payload };
    case AI_PRESUPUESTO_FAILURE:
      return { ...state, presupuestoLoading: false, error: action.payload };

    case AI_CLEAR_SESSION:
      return { ...state, sessionId: uuidv4(), lastPresupuesto: null };

    default:
      return state;
  }
};

export default aiReducer;
